<template>
    <div>
      <!-- 头部 -->
      <Banner :bgImg="bannerImg" :title="'xcpinyuepartner'"></Banner>
      <div class="tianqBox">
        <div class="indexYq bannerW indexpromoter">
          <div class="yqBox wow slideInUp">
            <div class="left">
              <p :class="['yqName',lang=='en'?'wd448 font40':'wd600 font60']">{{$t('xcpinyuepartner.summary.tit1')}}</p>
              <p :class="['yqDscp',lang=='en'?'wd448':'wd600']">{{$t('xcpinyuepartner.summary.tips1[0]')}}</p>
              <p :class="['yqDscp',lang=='en'?'wd448':'wd600']">{{$t('xcpinyuepartner.summary.tips2[0]')}}</p>
            </div>
            <div class="right">
              <img src="@/assets/images/tgy.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </template>
  
  <script>
    import Footer from "../../components/footerpinyue.vue";
    import Banner from "../../components/banner.vue";
    import bannerImg from  "@/assets/images/bg1.png"

    export default {
      name: "xcpinyuepartner",
      components: {
        Footer,
        Banner,
      },
      head() {
          return {
              "title": this.$t(`metaInfoData.xcpinyuepartner.title`),
              "keywords": this.$t(`metaInfoData.xcpinyuepartner.keywords`),
              "description": this.$t(`metaInfoData.xcpinyuepartner.description`)
          }
      },
      data(){
        return{
          lang: this.$i18n.locale,
          bannerImg:bannerImg,
        }
      },
    };
  </script>
  <style lang="scss" scoped>
    /* @import url("../assets/css/common.scss"); */
    @import url("https://fonts.googleapis.com/css?family=Work+Sans:400,700,900");
    $anim-text-offset: 1em;
    .style{
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      padding-left: 98px;
      padding-bottom: 143px;
      margin-top: 50px;
      .styleText{
        p{
          display: flex;
          flex-direction:column;
          span{
            line-height: 84px;
            display:block;
            width: 100%;
            font-size:60px;
            font-family:Microsoft YaHei;
            font-weight:600;
            color:rgba(34,34,34,1);
            text-align: center
          }
          .en{
            font-size:40px;
            line-height:56px;
          }
        }
       ul{
         margin-top: 40px;
         display: flex;
         flex-direction: column;
         align-items: center;
          .active{
            background:linear-gradient(270deg,rgba(1,121,233,1) 0%,rgba(0,182,255,1) 100%);
            box-shadow:0px 4px 20px 0px rgba(0,151,255,0.5);
            color:#fff;
          }
          &:hover li{
            background:rgba(250,250,250,1);
            color: #000;
            box-shadow:none;
          }
         li{
          font-size:20px;
          color:rgba(34,34,34,1);
          text-align:center;
          line-height:70px;
          width:287px;
          height:70px;
          background:rgba(250,250,250,1);
          margin-bottom: 15px;
          &:hover{
              cursor:pointer;
            /* width:287px; */
            /* height:70px; */
            background:linear-gradient(270deg,rgba(1,121,233,1) 0%,rgba(0,182,255,1) 100%);
            box-shadow:0px 4px 20px 0px rgba(0,151,255,0.5);
            color:#fff;
            /* text-align:center; */
            /* line-height:70px; */
          }
         }
        
       }
      }
    }
    .tqDesc{
          width:100%;
          height:170px;
          background:rgba(251,251,251,1);
          .bannerW{
            height:100%;
            display:flex;
            flex-direction:row;
            align-items: center;

          }
          ul{
            width:100%;
            display:flex;
            flex-direction:row;
            justify-content:space-between;
            li{
              display:flex;
              flex-direction:row;
              align-items:flex-start;
          .imgDesc{
              width: 66px;
              height:66px;
          }
          .imgText{
            margin-left: 15px;
            .name{
              font-size:20px;
              font-family:Microsoft YaHei;
              font-weight:600;
              color:rgba(34,34,34,1);
            }
            .name2{
              width: 210px;
            }
            .desc{
              font-size:16px;
              font-family:Microsoft YaHei;
              font-weight:400;
              color:rgba(153,153,153,1);
              margin-top:15px;
            }
            .desc0{
              width: 200px;
            }
            .desc2{
              width: 223px;
            }
            .desc3{
              width: 146px;
            }
          }
        }
      }
    }
  </style>